// ─── Visionneuse d'image plein écran (Core, réutilisable) ─────────
// Ouvre une image en grand (tap sur une vignette / pièce jointe image), depuis
// N'IMPORTE OÙ (écran, feuille, composant inline). Rendue via <Modal> : sur natif
// la Feuille parente est un CALQUE (pas un Modal) → une seule modale native ;
// sur web l'imbrication de modales est sans souci.
//   <VisionneuseImage url={url} onFermer={() => setZoom(null)} />
import React from 'react';
import { Modal, View, Image, TouchableOpacity, Text, StyleSheet, Dimensions } from 'react-native';

export default function VisionneuseImage({ url, visible = true, onFermer }) {
  const ouvert = !!url && !!visible;
  const { width, height } = Dimensions.get('window');
  return (
    <Modal visible={ouvert} transparent animationType="fade" onRequestClose={onFermer}>
      <TouchableOpacity style={st.fond} activeOpacity={1} onPress={onFermer} accessibilityLabel="Fermer l'image">
        {ouvert && (
          <Image source={{ uri: url }} style={{ width: width * 0.94, height: height * 0.82 }} resizeMode="contain" />
        )}
        <View style={st.fermer}><Text style={st.fermerTxt}>✕</Text></View>
      </TouchableOpacity>
    </Modal>
  );
}

const st = StyleSheet.create({
  fond:      { flex: 1, backgroundColor: 'rgba(0,0,0,0.92)', alignItems: 'center', justifyContent: 'center' },
  fermer:    { position: 'absolute', top: 46, right: 20, width: 40, height: 40, borderRadius: 20,
               backgroundColor: 'rgba(255,255,255,0.16)', alignItems: 'center', justifyContent: 'center' },
  fermerTxt: { color: '#fff', fontSize: 20, fontWeight: '800' },
});
